import { Theme } from '@mui/material/styles';
import { SxProps } from '@mui/system';

/**
 * Shared by both monthly charts, so the two read as one pair rather than as two components
 * that happen to sit near each other.
 */

export const chartCardStyles: SxProps<Theme> = {
    p: { xs: 2, sm: 3 },
    mb: 3,
    display: 'flex',
    flexDirection: 'column',
    // Load-bearing: a grid or flex child otherwise refuses to shrink below its content, and
    // the chart is handed a negative width.
    minWidth: 0,
    overflow: 'hidden',
};

export const chartTitleStyles: SxProps<Theme> = {
    fontWeight: 700,
};

export const chartSubtitleStyles: SxProps<Theme> = {
    color: 'text.secondary',
    display: 'block',
    mb: 1,
};

/** The caveat under the patients chart. Quiet, but it has to be on the page. */
export const chartNoteStyles: SxProps<Theme> = {
    color: 'text.secondary',
    display: 'block',
    mt: 1,
};

export const chartEmptyBoxStyles: SxProps<Theme> = {
    textAlign: 'center',
    py: 6,
    color: 'text.secondary',
};
